import { LayerEntity } from './layer-entity';
import { BboxValueObject } from '../value-objects/bbox-value-object';
import { SpatialReferenceEntity } from './spatial-reference-entity';
import { LogEntity } from './log-entity';

export class BookmarkEntity {
  id: number | null = null;
  name!: string;
  hash!: string;
  bbox!: BboxValueObject;
  spatialReference!: SpatialReferenceEntity;
  layers: LayerEntity[] = [];
  baseMap?: LayerEntity;
  log?: LogEntity;

  constructor(init?: Partial<BookmarkEntity>) {
    if (init) {
      if (init.name === undefined || init.name === null || init.name === '') {
        throw new Error('BookmarkEntity.name is required');
      }
      if (!init.bbox) {
        throw new Error('BookmarkEntity.bbox is required');
      }
      if (!init.spatialReference) {
        throw new Error('BookmarkEntity.spatialReference is required');
      }
    }
    Object.assign(this, init);
  }
}
